module.exports = __webpack_public_path__ + "img/IMG_2258.37782b61.jpg";